export const MUI_X_PRO_LICENSE =
  'f359d9c0d105599a7d83c3f8d775eca5Tz0xMjMsRT0yNTI0NjA0NDAwMDAwLFM9cHJlbWl1bSxMTT1wZXJwZXR1YWwsS1Y9Mg==';
export const HTML_ID_EDITOR_OVERLAY = 'editor-overlay';
export const WINDOW_PROP_TOOLPAD_APP_RENDER_PARAMS = '__TOOLPAD_APP_RENDER_PARAMS__';
export const RUNTIME_CONFIG_WINDOW_PROPERTY = '__TOOLPAD_RUNTIME_CONFIG__';

export const TOOLPAD_TARGET_CE = 'CE';
export const TOOLPAD_TARGET_CLOUD = 'CLOUD';
export const TOOLPAD_TARGET_PRO = 'PRO';
export const REPOSITORY_URL = 'https://github.com/mui/mui-toolpad';
export const LANDING_PAGE_URL = 'https://mui.com/toolpad/';
export const DOCUMENTATION_URL = 'https://mui.com/toolpad/getting-started/overview/';
export const DOCUMENTATION_INSTALLATION_URL =
  'https://mui.com/toolpad/getting-started/installation/';
export const ROADMAP_URL = 'https://github.com/orgs/mui/projects/9';
export const SCHEDULE_DEMO_URL = 'https://calendly.com/prakhar-mui/toolpad';

export const PRODUCTION_DATASOURCES = new Set([
  'rest',
  'function',
  'googleSheets',
  'postgres',
  'mysql',
  'local',
]);

export const TOOLPAD_BRIDGE_GLOBAL = '__TOOLPAD_BRIDGE__';

export const NON_BINDABLE_CONTROL_TYPES = ['GridColumns'];

export const VERSION_CHECK_INTERVAL = 1000 * 60 * 10;
